import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FaqPage.css';

const FaqPage = () => {
    const { t } = useTranslation();
    const [openIndex, setOpenIndex] = useState(null);

    // Списък с ключовете от JSON файла
    const faqKeys = [1, 2, 3, 4, 5, 6, 7, 8];

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="faq-container">
            <div className="faq-header">
                <h1 className="faq-title">{t('faq.title')}</h1>
                <p className="faq-subtitle">{t('faq.subtitle')}</p>
            </div>

            <div className="faq-accordion">
                {faqKeys.map((num, index) => {
                    const isOpen = openIndex === index;
                    return (
                        <div
                            key={num}
                            className={`faq-item ${isOpen ? 'open' : ''}`}
                        >
                            <button
                                className="faq-question"
                                onClick={() => toggleFaq(index)}
                                aria-expanded={isOpen}
                            >
                                <span>{t(`faq.q${num}`)}</span>
                                <span className="faq-icon">{isOpen ? '−' : '+'}</span>
                            </button>

                            <div className="faq-answer-wrapper">
                                <div className="faq-answer">
                                    <p>{t(`faq.a${num}`)}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FaqPage;